import { createRouter, createWebHistory } from "vue-router";
import silentLogin from "@/components/silent_login/Login.vue";
import ssoLogin from "@/components/sso/Login.vue";
import invoicePDF from "@/components/invoice/invoice.vue";
import appointmentDetail from "@/views/appointment/AppointmentDetail.vue";
import quoteDetail from "@/views/quote/QuoteDetail.vue";
import editQuote from "@/views/quote/QuoteEdit.vue";
import notfound from "@/views/NotFound.vue";
import login from "../views/nest_views/login.vue";
import dashboard from "../views/dashboard/dashboard.vue";
import servicerepairhistory from "../views/nest_views/service-repair-history.vue";
import jobdetail from "../views/nest_views/job-detail.vue";
import selectunit from "../views/nest_views/select-unit.vue";
import evaluation from "../views/nest_views/evaluation.vue";
import evaluationPreCheck from "../views/nest_views/evaluation-pre-check.vue";
import initialCheck from "../views/nest_views/initial-check.vue";
import outdoorequipment from "../views/nest_views/outdoor-equipment.vue";
import equipment from "../views/nest_views/indoor-outdoor-equipment.vue";
import indoorequipment from "../views/nest_views/indoor-equipment.vue";
import summary from "../views/nest_views/summary.vue";
import finalEvaluation from "../views/nest_views/final-evaluation.vue";
import summaryDetail from "../views/nest_views/summary-detail.vue";
import editSummary from "../views/nest_views/edit-summary.vue";
import success from "../views/nest_views/nest-success.vue";
import failure from "../views/nest_views/nest-success.vue";
import plan from "../views/protection-plan/plan.vue";
import salesHistory from "../views/protection-plan/sales-history.vue";
import commisionAmount from "../views/protection-plan/commision-amount.vue";
import register from "../views/nest_views/register.vue";
import verification from "../views/nest_views/verification.vue";
import forgetPassword from "../views/nest_views/reset-password.vue"
import search from "../views/globalSearch/search.vue";
import protectionPlans from "../views/protection-plan/index.vue";
import { faL } from "@fortawesome/free-solid-svg-icons";
import lastEvaluation from "../views/nest_views/last-evaluation.vue";
import checkoutDetail from "@/views/checkout/index.vue";
import checkoutRedirections from "@/views/checkout/redirections.vue";
import { constants } from "../helpers/helperFunction";
import { disableScroll, enableScroll } from "../helpers/scrollHelper";
import paymentLinkCheckoutRedirections from "@/views/checkout/paymentLinkRedirections.vue";
import omegaListing from "../views/omega/affiliate/affiliateListing.vue";
import partnerList from "../views/protection-plan-partner/bundle-list.vue";
import partnerCheckout from "../views/protection-plan-partner/partner-checkout/chekout.vue";
import thankyou from "../views/protection-plan-partner/partner-checkout/thankyou.vue";
import commonParts from "../views/nest_views/commonParts.vue";
import productList from "../views/protection-plan-partner/products.vue";
import termsAndConditions from "../views/protection-plan-partner/partner-checkout/terms-and-condtion.vue";
import dashboardHappyHome from "../views/myHappyHome/dashboard.vue";
import jobInvoice from "../views/nest_views/job-invoice.vue";

const routes = [
    {
        path: "/login",
        name: "login",
        component: login,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/register",
        name: "register",
        component: register,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/verification",
        name: "verification",
        component: verification,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/forgetPassword",
        name: "forgetPassword",
        component: forgetPassword,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/",
        name: "silentLogin",
        component: silentLogin,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/sso",
        name: "ssoLogin",
        component: ssoLogin,
        meta: {
            layout: 'auth'
        }
    },
    {
        path: "/appointment/detail/:id",
        name: "AppointmentDetail",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.APPOINTMENT_TITLE,
            layout: 'auth'
        },
        component: appointmentDetail,
    },
    {
        path: "/quote/detail/:id",
        name: "QuoteDetail",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.UQ_TITLE,
            layout: 'auth'

        },
        component: quoteDetail,
    },
    {
        path: "/quote/edit/:id",
        name: "QuoteEdit",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.UQ_TITLE,
            layout: 'auth'
        },
        component: editQuote,
    },
    {
        path: "/not-found",
        name: "NotFound",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: notfound,
    },
    // nest_view router

    {
        path: "/dashboard",
        name: "dashboard",
        component: dashboard,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/service-repair-history",
        name: "service-repair-history",
        component: servicerepairhistory,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/job/detail/:id",
        name: "job-detail",
        component: jobdetail,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/select/unit/:id",
        name: "select-unit",
        component: selectunit,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/evaluation",
        name: "evaluation",
        component: evaluation,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/evaluation-pre-check",
        name: "evaluation-pre-check",
        component: evaluationPreCheck,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/initial-check/:id",
        name: "initial-check",
        component: initialCheck,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/outdoor-equipment/:id",
        name: "outdoor-equipment",
        component: outdoorequipment,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/equipment/:id",
        name: "equipment",
        component: equipment,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/indoor-equipment",
        name: "indoor-equipment",
        component: indoorequipment,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/summary/:id",
        name: "summary",
        component: summary,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/final-evaluation/:id",
        name: "final-evaluation",
        component: finalEvaluation,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/summary-detail/:id",
        name: "summary-detail",
        component: summaryDetail,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/edit-summary/:id",
        name: "edit-summary",
        component: editSummary,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    }, {
        path: "/success",
        name: "success",
        component: success,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
    },
    {
        path: "/failure",
        name: "failure",
        component: failure,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
    },
    // protection plan routes
    {
        path: "/plans/nrg/:id",
        name: "protections-plans",
        component: protectionPlans,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main'
        },
    },

    // {
    //     path: "/protection-plan/nrg/bundle-list",
    //     name: "hvac-plan",
    //     component: bundleList,
    //     meta: {
    //         requiresAuth: true, // Add meta field to indicate protected route
    //         layout: 'main'
    //     },
    // },



    {
        path: "/protection-plan/nrg/plan",
        name: "plan",
        component: plan,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/sales-history",
        name: "salesHistory",
        component: salesHistory,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/protection-plan/commissions",
        name: "commisionAmount",
        component: commisionAmount,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },



    {
        path: "/protection-plan/:partnerSlug/products",
        name: "products",
        component: productList,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },


    {
        path: "/protection-plan/:partnerSlug/:routeSlug",
        name: "partner",
        component: partnerList,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },

    {
        path: "/global-search",
        name: "globalSearch",
        component: search,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            layout: 'main'
        },
    },
    {
        path: "/checkout/invoice/:id",
        name: "checkoutDetail",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.CHECKOUT_TITLE,
            layout: 'auth'
        },
        component: checkoutDetail,
    },
    // {
    //     path: "/protection-plan/nrg/bundle-list",
    //     name: "bundleList",
    //     component: bundleList,
    //     meta: {
    //         requiresAuth: true, // Add meta field to indicate protected route
    //         layout: 'main'
    //     },
    // },
    {
        path: "/last-evaluation/:id",
        name: "last-evaluation",
        component: lastEvaluation,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/checkout-success",
        name: "checkoutSuccess",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: checkoutRedirections,
    },
    {
        path: "/checkout-failed",
        name: "checkoutFailed",
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: checkoutRedirections,
    },
    {
        path: "/checkout/:id/success",
        name: "paymentLinkCheckoutSuccess",
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: paymentLinkCheckoutRedirections,
    },
    {
        path: "/checkout/:id/fail",
        name: "paymentLinkCheckoutFailed",
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'auth'
        },
        component: paymentLinkCheckoutRedirections,
    },

    // ------------------------
    // omega 
    {
        path: "/affiliates",
        name: "omegaListing",
        component: omegaListing,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'main'
        },
    },

    // ------------------------
    // partner-checkout 
    {
        path: "/partner/checkout",
        name: "partnerCheckout",
        component: partnerCheckout,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'main'
        },
    },
    // ------------------------
    // partner-checkout 
    {
        path: "/thankyou",
        name: "thankyou",
        component: thankyou,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    },
    // ------------------------

    // ------------------------
    // Terms and Conditon
    {
        path: "/terms-and-conditions",
        name: "termsAndConditions",
        component: termsAndConditions,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    }, 
    // ------------------------
{
        path: "/happyhome/dashboard",
        name: "dashboardHappyHome",
        component: dashboardHappyHome,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            layout: 'main' 
            // layout: 'default'
        },
    }, 
    {
        path: "/price-list",
        name: "commonParts",
        component: commonParts,
        meta: {
            requiresAuth: false, // Add meta field to indicate protected route
            // layout: 'main' 
            layout: 'default'
        },
    },
    
    {
        path: "/job/invoice/:id",
        name: "job-invoice",
        component: jobInvoice,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    {
        path: "/invoice/:id",
        name: "invoicePDF",
        component: invoicePDF,
        meta: {
            requiresAuth: true, // Add meta field to indicate protected route
            title: constants.SAR_TITLE,
            layout: 'auth'
        },
    },
    // ------------------------

    // {
    //   path: '/:pathMatch(.*)*',
    //   name: 'NotFound',
    //   meta: {
    //     requiresAuth: true // Add meta field to indicate protected route
    //   },
    //   component: notfound
    // },
    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // },
    // {
    //   path: '/products',
    //   name: 'Products',
    //   component: () => import('../views/products/ProductList.vue')
    // },
    // {
    //   path: '/products/create',
    //   name: 'Product Create',
    //   component: () => import('../views/products/ProductCreate.vue')
    // },
    // {
    //   path: '/products/edit/:id',
    //   name: 'ProductEdit',
    //   component: () => import('../views/products/ProductEdit.vue')
    // }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeResolve((to, from, next) => {
    if (to.name) {

    }
    next();
});

router.afterEach(() => {

});




router.beforeEach((to, from, next) => {

    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
        backdrop.remove();
    }
    // $(".modal-backdrop").remove();
    document.body.classList.remove('modal-open');
    document.documentElement.style.overflow = 'auto'; // html
    document.body.style.paddingRight = '';
    enableScroll()

    const modalEl = document.getElementById('maintenanceModal')
    // console.log("testests", modalEl);
    if (modalEl && modalEl.classList.contains('show')) {
        modalEl.classList.remove('show')
        modalEl.style.display = '';
        modalEl.setAttribute('aria-hidden', 'true');
        modalEl.removeAttribute('aria-modal');
        modalEl.removeAttribute('role');
    }

    let tempUser = localStorage.getItem("user") ?? null;
    let isSilentLogin = localStorage.getItem("isSilentLogin", false) ?? false;
    let isProtectionPlans = localStorage.getItem("isProtectionPlans", false) ?? false;


    // console.log("isSilentLogin", isSilentLogin);

    if (isSilentLogin == 'true') {
        if (to.meta.layout == "auth" && tempUser) {
            return next();
        } else if (isProtectionPlans && tempUser) {
            return next();
        } else {

            if(to.path == "/price-list" ){
                return next();
            }
            else{
            setTimeout(() => {
                localStorage.removeItem('user')
                localStorage.removeItem('isSilentLogin')
                localStorage.removeItem('isProtectionPlans')
                localStorage.removeItem('is_from_mobile')

                return next({
                    path: '/login'
                });
            }, 300);
         }
        }
    } else if ((to.path == "/login" || to.path == "/register" || to.path == "/verification") && tempUser) {
        return next({ path: "/protection-plan/nrg/bundle-list" });
    } 
    else if (to.meta.requiresAuth) {
        if (tempUser != null) {
            // User is authenticated, proceed to the route
            return next();
            
        } else {
            // User is not authenticated, redirect to login
            if(to.path == "/price-list" ){
                return next();
            }
            else{
                setTimeout(() => {
                    localStorage.removeItem('user')
                    localStorage.removeItem('isSilentLogin')
                    localStorage.removeItem('isProtectionPlans')
                    localStorage.removeItem('is_from_mobile')
    
                    return next({
                        path: '/login'
                    });
                }, 300);
            }
    
        }
    } else {
        return next();
    }
});

export default router;
